import { IMealIngredientsCount } from './mealingredient';

export class MealIngredientCount {
    public quantity: number;
    public ingredientId: string;
    public displayData: IMealIngredientsCount; // calculated property for display only
}
